import { render, staticRenderFns } from "./AppConfigurationPage.vue?vue&type=template&id=610f075a&scoped=true"
import script from "./AppConfigurationPage.vue?vue&type=script&lang=js"
export * from "./AppConfigurationPage.vue?vue&type=script&lang=js"
import style0 from "./AppConfigurationPage.vue?vue&type=style&index=0&id=610f075a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610f075a",
  null
  
)

export default component.exports